<template>
  <b-overlay :show="pending">
    <b-container class="support-form position-relative mb-4" fluid="sm">
      <language-selection class="language"></language-selection>
      <!-- <div v-if="isPopup === 'true'" class="boxclose" @click="close()"></div> -->
      <h3 class="form-header">
        {{ $t("help_welcome") }}
      </h3>
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('help_subject_label')" label-for="input-0">
          <b-container class="position-relative">
            <b-form-input
              class="icon-indent"
              id="input-0"
              v-model="form.subject"
              type="text"
              :state="Boolean(form.subject)"
              required
              :placeholder="$t('help_subject_placeholder')"
            ></b-form-input>
            <i class="fas fa-comment form-icons"></i>
          </b-container>
        </b-form-group>

        <b-form-group :label="$t('help_username_label')" label-for="input-1">
          <b-container class="position-relative">
            <b-form-input
              class="icon-indent"
              id="input-1"
              v-model="form.username"
              type="text"
              disabled
            ></b-form-input>
            <i class="fas fa-user form-icons"></i>
          </b-container>
        </b-form-group>

        <b-form-group :label="$t('partner_report_game')" label-for="input-2">
          <b-container class="position-relative">
            <b-form-input
              class="icon-indent"
              id="input-2"
              v-model="form.game"
              type="text"
              disabled
            ></b-form-input>
            <i class="fas fa-tag form-icons"></i>
          </b-container>
        </b-form-group>

        <b-form-group :label="$t('help_question_label')" label-for="input-3">
          <b-container class="position-relative">
            <b-form-select
              class="icon-indent"
              id="input-3"
              v-model="form.type"
              :options="typeOptions"
              :state="Boolean(form.type)"
              required
            ></b-form-select>
            <i class="fas fa-question-circle form-icons"></i>
          </b-container>
        </b-form-group>
        <div v-if="showPayment">
          <b-form-group
            :label="$t('help_payment_date_label')"
            label-for="input-4"
          >
            <b-container class="">
              <b-form-datepicker
                id="input-4"
                v-model="form.paymentDate"
                :state="Boolean(form.paymentDate)"
              ></b-form-datepicker>
            </b-container>
          </b-form-group>

          <b-form-group
            :label="$t('help_payment_time_label')"
            label-for="input-5"
          >
            <b-container class="position-relative">
              <b-form-input
                class="icon-indent"
                id="input-5"
                v-model="form.paymentTime"
                :state="Boolean(form.paymentTime)"
                type="text"
              ></b-form-input>
            </b-container>
          </b-form-group>

          <b-form-group
            :label="$t('help_payment_amount_label')"
            label-for="input-6"
          >
            <b-container class="position-relative">
              <b-form-input
                class="icon-indent"
                id="input-6"
                v-model="form.paymentAmount"
                :state="Boolean(form.paymentAmount)"
                type="text"
              ></b-form-input>
            </b-container>
          </b-form-group>

          <b-form-group
            :label="$t('help_payment_method_label')"
            label-for="input-7"
          >
            <b-container class="position-relative">
              <b-form-select
                class="icon-indent"
                id="input-7"
                v-model="form.paymentMethod"
                :state="Boolean(form.paymentMethod)"
                :options="methodOptions"
              ></b-form-select>
            </b-container>
          </b-form-group>

          <b-form-group
            v-if="showPaymentMethodOther"
            :label="$t('help_payment_method_other_specify_label')"
            label-for="input-7.1"
          >
            <b-container class="position-relative">
              <b-form-input
                class="icon-indent"
                id="input-7.1"
                v-model="form.paymentOtherMethod"
                :state="Boolean(form.paymentOtherMethod)"
              ></b-form-input>
            </b-container>
          </b-form-group>
        </div>

        <b-form-group :label="$t('help_message_label')" label-for="input-8">
          <b-container class="position-relative">
            <b-form-textarea
              class="icon-indent"
              v-model="form.message"
              rows="3"
              :placeholder="$t('help_message_placeholder')"
              required
            ></b-form-textarea>

            <i class="fas fa-comment form-icons"></i>
          </b-container>
        </b-form-group>

        <b-form-group :label="$t('help_upload_label')" label-for="input-9">
          <b-container class="position-relative">
            <b-form-file
              accept=".jpg, .png,"
              class="icon-indent"
              v-model="form.files"
              multiple
              :placeholder="$t('help_upload_browse')"
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <i class="fas fa-paperclip form-icons"></i>
          </b-container>
        </b-form-group>

        <b-form-group :label="$t('help_email_label')" label-for="input-10">
          <b-container class="position-relative">
            <b-form-input
              class="icon-indent"
              id="input-10"
              v-model="form.email"
              type="email"
              :placeholder="$t('help_email_placeholder')"
              required
            ></b-form-input>
            <i class="fas fa-envelope form-icons"></i>
          </b-container>
        </b-form-group>

        <b-container class="text-center position-relative">
          <b-form-invalid-feedback :state="formValidation">
            {{ formError }}
          </b-form-invalid-feedback>
        </b-container>

        <b-container class="text-center position-relative">
          <button
            type="submit"
            class="btn btn-primary solid btn-sm mx-auto mb-3 w-100"
          >
            {{ $t("send") }}
          </button>
          <button
            type="button"
            class="btn btn-default solid btn-sm mx-auto w-100"
            @click="goBack"
          >
            {{ $t("cancel") }}
          </button>
        </b-container>
      </b-form>
    </b-container>
  </b-overlay>
</template>

<script>
import LanguageSelection from "../components/LanguageSelection";
import Api from "../core/Api";
import EventBus from "../core/EventBus";

export default {
  name: "Support",
  components: {
    LanguageSelection
  },
  data() {
    return {
      showSupportScreen: true,
      form: {
        username: this.$store.getters.getUser.username,
        game: this.$store.getters.getGame.gameName,
        type: null,
        paymentMethod: null
      },
      formError: null,
      pending: false,
      maxFileSizeInMB: 2,
      typeOptions: [
        {
          value: null,
          text: this.$t("help_question_option_default"),
          disabled: true
        },
        { value: "payment", text: this.$t("help_question_option_1") },
        { value: "bug", text: this.$t("help_question_option_2") },
        { value: "item", text: this.$t("help_question_option_3") },
        { value: "loading", text: this.$t("help_question_option_4") },
        { value: "suggestion", text: this.$t("help_question_option_6") },
        { value: "gameplay_plinga", text: this.$t("help_question_option_10") },
        { value: "account_plinga", text: this.$t("help_question_option_11") },
        { value: "another", text: this.$t("help_question_option_7") },
        {
          value: "gdpr_question",
          text: this.$t("help_question_option_8")
        },
        {
          value: "gdpr_sar",
          text: this.$t("help_question_option_9")
        }
      ],
      methodOptions: [
        {
          value: null,
          text: this.$t("help_payment_method_option_default"),
          disabled: true
        },
        {
          value: "bank_transfer",
          text: this.$t("help_payment_method_option_1")
        },
        {
          value: "credit_card",
          text: this.$t("help_payment_method_option_2")
        },
        { value: "mobile", text: this.$t("help_payment_method_option_3") },
        { value: "paypal", text: this.$t("help_payment_method_option_4") },
        {
          value: "another_method",
          text: this.$t("help_payment_method_option_5")
        }
      ]
    };
  },
  computed: {
    showPayment() {
      return this.form.type === "payment";
    },
    formValidation() {
      return !this.formError;
    },
    showPaymentMethodOther() {
      return this.form.paymentMethod === "another_method";
    }
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();

      const vm = this;
      vm.pending = true;

      const params = {
        platform: this.$store.getters.getGame.platform,
        domain: this.$store.getters.getDomain,
        userid: this.$store.getters.getUser.uid,
        locale: this.$store.getters.getLocale,
        isGuest: this.$store.getters.getUser.is_guest,
        attachments: [],
        ...this.form
      };

      if (
        this.form.type === "payment" &&
        (!this.form.paymentMethod ||
          !this.form.paymentDate ||
          !this.form.paymentAmount ||
          !this.form.paymentTime)
      ) {
        this.formError = "Please fill required fields.";
        vm.pending = false;
        return null;
      }

      if (this.form.files?.length > 0) {
        const exceededSizes = this.form.files.filter(
          f => f.size > this.maxFileSizeInMB * 1024 * 1024
        );

        if (exceededSizes.length > 0) {
          this.formError = "Maximum 2 MB file is allowed.";
          vm.pending = false;
          return null;
        }

        this.form.files.forEach(file => {
          const reader = new FileReader();
          reader.onload = e => {
            params.attachments.push({
              filename: file.name,
              type: file.type,
              data: e.target.result
            });
          };
          reader.readAsDataURL(file);
        });
      }

      const paymentInfo = await Api.fetchPaymentInfo({
        userid: this.$store.getters.getUser.uid,
        platform: this.$store.getters.getGame.platform,
        game: this.$store.getters.getGame.gameName
      });
      params.firstBuyer = paymentInfo.success
        ? paymentInfo?.result?.first_buyer
          ? 1
          : 0
        : 0;

      delete params.files;

      this.$store
        .dispatch("sendZendeskTicket", params)
        .then(response => {
          console.log(response);
          vm.pending = false;

          new EventBus().broadcast("NOTIFICATION", {
            success: true,
            message: `${vm.$t("ticket_submit_message")}. ${vm.$t(
              "help_welcome"
            )}`
          });

          vm.goBack();
        })
        .catch(err => {
          new EventBus().broadcast("NOTIFICATION", {
            success: false,
            message: err.message ? err.message : err
          });
          vm.pending = false;
        });
    },
    goBack() {
      this.$emit("close");
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeMount() {
    this.game = this.$store.getters.getGame;
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
